export const NAMESPACE = "EventDetails";

export const STATUS = {
  CLOSED: "closed",
  OPEN: "open"
};
